<div class="py-6">
  <app-table
      [loading]="loading"
      [data]="tableData"
      [columns]="tableColumns"
      [filters]="tableFilters"
      [pagination]="true"
      id="table-committeeProjectTable" />
</div>
